// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myvehicles-div {
  position: relative;
  border: 1px solid #f2f2f2;
  border-radius: 12px;
  padding-block: 2rem;
  padding-right: 1rem;
  margin-block: 1rem;
}
.myvehicles-div .vehicle-default {
  position: absolute;
  margin-top: -3rem;
  margin-left: 1rem;
  font-size: 12px;
  background-color: #e6f7ef;
  color: #00aa74;
  padding-block: 4px;
  padding-inline: 10px;
  border-radius: 8px;
}

.myvehicle--content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vehicles {
  display: flex;
  gap: 2rem;
  align-items: center;
}
.vehicles .vehicles-details {
  width: 180px;
}
.vehicles .vehicles-details p:first-child {
  font-size: 14px;
  padding-bottom: 0.5rem;
}
.vehicles .vehicles-details p:last-child {
  font-size: 12px;
  color: #8c8c8c;
}

.vehicles-modal {
  margin-top: -5.4rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/MyVehiclesCard/style.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AACA;EAII,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;AAII;EACI,kBAAA;EAEA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBCfQ;EDgBR,cCjBQ;EDkBR,kBAAA;EACA,oBAAA;EACA,kBAAA;AAHR;;AAMA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAHJ;;AAKA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAGI;EACI,YAAA;AADR;AAEQ;EACI,eAAA;EACA,sBAAA;AAAZ;AAEQ;EACI,eAAA;EACA,cC3BK;AD2BjB;;AAIA;EACI,mBAAA;AADJ","sourcesContent":["@import '../../../Styles/sass/variables';\n.myvehicles-div {\n    // display: flex;\n    // justify-content: space-between;\n    // align-items: center;\n    position: relative;\n    border: 1px solid $color_grey_100;\n    border-radius: 12px;\n    padding-block: 2rem;\n    padding-right: 1rem;\n    margin-block: 1rem;\n    .vehicle-default{\n        position: absolute;\n    //    display: inline-block;\n        margin-top: -3rem;\n        margin-left: 1rem;\n        font-size: 12px;\n        background-color: $primary_light;\n        color: $primary_green;\n        padding-block: 4px;\n        padding-inline:10px;\n        border-radius: 8px;\n    }\n}\n.myvehicle--content{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.vehicles{\n    display: flex;\n    gap: 2rem;\n    align-items: center;\n    .vehicles-details {\n        width: 180px;\n        p:first-child {\n            font-size: 14px;\n            padding-bottom: 0.5rem;\n        }\n        p:last-child {\n            font-size: 12px;\n            color: $color_grey_400;\n        }\n    }\n}\n.vehicles-modal {\n    margin-top: -5.4rem;\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
